import { ActivatedRouteSnapshot, Data } from '@angular/router';

/**
 * Route data for a page whose top header stays on screen while it scrolls (AT-2626). Only the landing page: it is
 * long and the header holds its only sign-in link. Elsewhere a pinned header costs more than it gives; on the public
 * campaign page it stacked with the DS apply bar on a phone.
 */
export const STICKY_HEADER_DATA: Data = { stickyHeader: true };

/** Whether the active route, or any route above it, carries {@link STICKY_HEADER_DATA}. */
export const wantsStickyHeader = (root: ActivatedRouteSnapshot): boolean => {
  for (let route: ActivatedRouteSnapshot | null = root; route; route = route.firstChild) {
    if (route.data['stickyHeader'] === true) return true;
  }
  return false;
};
